import React from "react";
import "./QuantityPicker.css";

const QuantityPicker = ({ value, onChange, min = 1, max = 99 }) => {
  const dec = () => {
    if (value > min) onChange(value - 1);
  };

  const inc = () => {
    if (value < max) onChange(value + 1);
  };

  return (
    <div className="quantity-picker">
      <button type="button" className="quantity-btn" onClick={dec} disabled={value <= min}>
        −
      </button>
      <span className="quantity-value">{value}</span>
      <button type="button" className="quantity-btn" onClick={inc} disabled={value >= max}>
        +
      </button>
    </div>
  );
};

export default QuantityPicker;
